<template>
  <div>
    <div>
      <v-row class="ma-0">
        <v-chip color="yellow" class="text-h6">QUICK SELECT</v-chip>
      </v-row>
      <v-row class="pb-0">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-autocomplete
            v-model="quickSelectRandValue"
            :items="uniqueRandValues()"
            label="SELECT LOAN AMOUNT"
            item-text="displayValue"
            item-value="randValue"
          >
            <template v-slot:item="{ item }">
              <span style="text-align: right; display: block; width: 100%">
                {{ item.displayValue }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <!--create v-radio listing all the avalable loanTypes for the selected randValue -->
      <v-row class="pb-6">
        <v-col>
          <v-radio-group v-model="selected[0]">
            <v-radio
              v-for="loanType in loanTypes
                .filter((lt) => lt.randValue === quickSelectRandValue)
                .sort((a, b) => a.periodNumber - b.periodNumber)"
              :key="loanType.id"
              :label="`Repay : ${formatCurrency(
                loanType.payment
              )} per month for ${loanType.periodNumber} ${getPeriod(
                loanType.periodNumber
              )}`"
              :value="loanType"
              @click="(selected = [loanType]), (panel = [])"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel
        v-for="periodNumber in periodNumbers"
        :key="periodNumber"
      >
        <v-expansion-panel-header>
          <v-row class="ma-0">
            <v-chip color="yellow" class="text-h6 mr-2"
              >TERM OF CONTRACT: {{ periodNumber }}
              {{ getPeriod(periodNumber) }}</v-chip
            >
            <!-- <v-spacer></v-spacer> -->
            <v-chip class="text-h8" v-if="includesCreditLife(periodNumber)"
              >INCLUDES CREDIT LIFE</v-chip
            >
            <v-chip class="text-h8" v-else>NO CREDIT LIFE</v-chip>
            <v-spacer></v-spacer>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pb-6">
            <v-col>
              <v-card>
                <v-data-table
                  v-model="selected"
                  @input="resetQuickSelect"
                  :headers="headers"
                  :items="loanTypesByPeriod(periodNumber)"
                  :single-select="singleSelect"
                  :items-per-page="1000"
                  item-key="id"
                  sort-by="randValue"
                  show-select
                  class="grey lighten-4"
                  hide-default-footer
                >
                  <template v-slot:[`item.randValue`]="{ item }">
                    {{ 'R' + item.randValue.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.adminFee`]="{ item }">
                    {{ 'R' + item.adminFee.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.totalInterest`]="{ item }">
                    {{ 'R' + item.totalInterest.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.creditLifeFee`]="{ item }">
                    {{ 'R' + item.creditLifeFee.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.serviceCharge`]="{ item }">
                    {{ 'R' + item.serviceCharge.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.payment`]="{ item }">
                    {{ 'R' + item.payment.toFixed(2) }}
                  </template>
                  <template v-slot:[`item.totalPayment`]="{ item }">
                    {{ 'R' + item.totalPayment.toFixed(2) }}
                  </template>
                </v-data-table></v-card
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ApplicationTable',
  props: {
    value: Object,
    loanTypes: Array,
  },
  data: () => ({
    singleSelect: true,
    selected: [],
    quickSelectRandValue: null,
    headers: [],
    periodNumbers: [],
    period: '',
    panel: [],
  }),
  mounted() {
    this.headers = [
      {
        text: 'Loan Amount',
        value: 'randValue',
        class: 'grey lighten-2',
        sortable: false,
      },
      {
        text: 'Term',
        value: 'periodNumber',
        sortable: false,
      },
      {
        text: 'Initial fee once off',
        value: 'adminFee',
        class: 'grey lighten-2',
        sortable: false,
      },
      {
        text: 'Interest',
        value: 'totalInterest',
        sortable: false,
      },
      {
        text: 'Credit life per month',
        value: 'creditLifeFee',
        class: 'grey lighten-2',
        sortable: false,
      },
      {
        text: 'Service fee per month',
        value: 'serviceCharge',
        sortable: false,
      },
      {
        text: `Payment per ${this.getHeaderPeriod()}`,
        value: 'payment',
        class: 'grey lighten-2',
        sortable: false,
      },
      {
        text: 'Total Payment',
        value: 'totalPayment',
        sortable: false,
      },
      {
        text: 'For office use',
        value: 'code',
        class: 'grey lighten-2',
        sortable: false,
      },
    ];

    this.periodNumbers = [
      ...new Set(this.loanTypes.map((obj) => obj.periodNumber)),
    ].sort((a, b) => a - b);

    this.period = [...new Set(this.loanTypes.map((obj) => obj.period))].sort(
      (a, b) => a - b
    );
  },
  methods: {
    getHeaderPeriod() {
      if (this.$route.params.salaryFrequency === 'Monthly') {
        return 'Month';
      } else if (this.$route.params.salaryFrequency === 'Weekly') {
        return 'Week';
      } else if (this.$route.params.salaryFrequency === 'Fortnightly') {
        return 'Fortnight';
      }
    },
    getPeriod(periodNumber) {
      let result = this.loanTypes.filter(
        (lt) => lt.periodNumber === periodNumber
      );
      if (periodNumber == 1) {
        if (result[0].period === 'Months') {
          return 'Month';
        } else if (result[0].period === 'Wks/Mths') {
          return 'Week/Month';
        } else if (result[0].period === 'Weeks') {
          return 'Week';
        } else if (result[0].period === 'Fortnights') {
          return 'Fortnight';
        }
      } else {
        return result[0].period;
      }
    },
    loanTypesByPeriod(periodNumber) {
      let result = this.loanTypes.filter(
        (lt) => lt.periodNumber === periodNumber
      );

      let resultAddedR = _.cloneDeep(result);
      return resultAddedR;
    },
    uniqueRandValues() {
      let randValues = this.loanTypes.map((lt) => lt.randValue);
      return [...new Set(randValues)]
        .sort((a, b) => a - b)
        .map((value) => ({
          randValue: value,
          displayValue: new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: 'ZAR',
          }).format(value),
        }));
    },
    resetQuickSelect() {
      // Reset quick select when a selection is made in the data table and the selectted valie is different from the quick select value

      if (
        this.selected.length > 0 &&
        this.selected[0]?.randValue !== this.quickSelectRandValue
      ) {
        this.quickSelectRandValue = null;
      }
    },
    formatCurrency(value) {
      if (!value) return '';
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
      }).format(value);
    },
    includesCreditLife(periodNumber) {
      let result = this.loanTypes.filter(
        (lt) => lt.periodNumber === periodNumber
      );
      for (let r in result) {
        if (result[r].creditLifeFee > 0) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    selected: {
      handler() {
        this.$emit(
          'input',
          this.selected.length === 0 ? null : this.selected[0]
        );
      },
    },
  },
};
</script>
